// Fit-KPI weighting. The server stores raw, weight-agnostic sub-scores; the
// client applies the user's tunable weights and re-ranks instantly, so moving a
// slider never re-calls the model. Ported from apps/web/lib/scoring.ts +
// the server-side freshness_score (both live here now, one source of truth).
// Senior-seeker default: seniority fit weighted highest (calibrated) so a
// fundamental role mismatch is not rescued by a strong skills match.
export const DEFAULT_WEIGHTS = {
    seniority: 0.35,
    domain: 0.22,
    edge: 0.15,
    skills: 0.1,
    work_mode: 0.08,
    comp: 0.05,
    freshness: 0.05,
};
export const SUB_SCORE_KEYS = [
    'seniority',
    'domain',
    'skills',
    'edge',
    'work_mode',
    'comp',
    'freshness',
];
/**
 * Weighted overall on the 0-10 scale. A null sub-score (no evidence / unknown)
 * is excluded from BOTH numerator and denominator, never treated as a zero.
 */
export function computeOverall(subScores, weights) {
    let numerator = 0;
    let denominator = 0;
    for (const key of Object.keys(weights)) {
        const weight = weights[key] ?? 0;
        const score = subScores[key];
        if (score == null || weight <= 0)
            continue;
        numerator += weight * score;
        denominator += weight;
    }
    return denominator === 0 ? 0 : numerator / denominator;
}
/** Attach an overall to each role and sort highest-fit first. */
export function rankRoles(rows, weights) {
    return rows
        .map((row) => ({ ...row, overall: computeOverall(row.subScores, weights) }))
        .sort((a, b) => b.overall - a.overall);
}
/** Map a posting age (days) to a 0-10 freshness score; null if age unknown. */
export function freshnessScore(ageDays) {
    if (ageDays === null)
        return null;
    if (ageDays <= 3)
        return 10;
    if (ageDays >= 60)
        return 0;
    // Linear decay from 10 (day 3) to 0 (day 60).
    return Math.round((10 * (60 - ageDays)) / 57);
}
/** Days between `freshnessTs` and now (UTC), or null when the timestamp is absent. */
export function ageDays(freshnessTs, now) {
    if (freshnessTs === null)
        return null;
    return (now.getTime() - freshnessTs.getTime()) / 86_400_000;
}
//# sourceMappingURL=fit.js.map